import axios from "axios";
import log from "./game-log";
import config from '../config';

const GameApi = {
    version: {
        "number": "0.0.1",
        "build": "dev",
        "hash": "dev",
        "branch": "none",
        "version": "0.0.1-dev"
    },
    makeAbsolutePath: function(path) {
        return `${config.GAME_SERVER_BASE_URL}${path}`;
    },
    get: function(path, config) {
        path = this.makeAbsolutePath(path);
        return axios.get(path, config)
            .then(response => {
                this.checkApiVersion(response);
                log.trace(response, 'response for api.get %s', path);
                return response;
            })
            .catch(response => {
                return this.handleError(response);
            });
    },
    put: function(path, data, config) {
        path = this.makeAbsolutePath(path);
        return axios.put(path, data, config)
            .then(response => {
                log.trace(response, 'response for api.put %s', path);
                return response;
            })
            .catch(response => {
                return this.handleError(response);
            });
    },
    post: function(path, data, config) {
        path = this.makeAbsolutePath(path);
        return axios.post(path, data, config)
            .then(response => {
                log.trace(response, 'response for api.post %s', path);
                return response;
            })
            .catch(response => {
                return this.handleError(response);
            });
    },
    delete: function(path, config) {
        path = this.makeAbsolutePath(path);
        return axios.delete(path, config)
            .then(response => {
                log.trace(response, 'response for api.delete %s', path);
                return response;
            })
            .catch(response => {
                return this.handleError(response);
            });
    },
    spread: function(...args) {
        return axios.spread(...args);
    },
    all: function(requests) {
        return axios.all(requests)
            .then(responses => {
                responses.forEach(r => {this.checkApiVersion(r);});
                log.trace({responses: responses}, 'response for api.all');
                return responses;
            })
            .catch(response => {
                return this.handleError(response);
            });
    },
    checkApiVersion: function(response) {
        if (response.headers['api-version'] && response.headers['api-version'] !== this.version.version) {
            window.location.reload(true);
        }
    },
    handleError: function(response) {
        if (response instanceof Error) {
            // Something happened in setting up the request that triggered an Error
            const url = response.response && response.response.config ? response.response.config.url : '';
            log.error(response, 'error during request for ' + url);
            if (response.response && response.response.status === 401) {
                log.error('invalid user');
            }
            return Promise.reject(response);
        } else {
            // The request was made, but the server responded with a status code
            // that falls out of the range of 2xx
            const url = response.config ? response.config.url : '';
            const status = response.status;
            log.error({response}, `response status ${status} was out of range for ${url}`);
            if (status === 401) {
                log.error('invalid user');
            }
            return Promise.reject(response);
        }
    },
}
export default GameApi;